module.exports = __webpack_public_path__ + "media/Video 126.f1881635.mp4";